// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__dGhI6","label":"Completed_label__1fZi0"};